<ngx-extended-pdf-viewer backgroundColor='#ffffff' pageViewMode='infinite-scroll' zoom='auto' [base64Src]='pdf'>
</ngx-extended-pdf-viewer>
<div class='p-5 flex align-items-center justify-content-between relative'>
  <div class='grid justify-content-between w-full md:flex-column lg:flex-row'>
    <div class='flex justify-content-evenly align-items-center w-full'>
      <div class='col-12'>
        <div class='grid text-left'>
          <div class='col-12'>
            @if (!signStarted) {
              <p>{{ signText }} Pentru semnare apăsați "{{ signLabel }}".</p>
              <button type='button' class='p-button-raised px-4 pb-1 pt-2 p-button-rounded button-ipensii' pButton
                      pRipple [label]='signLabel' (click)='start()'>
              </button>
            } @else {
              @if (otpExpired) {
                <p>Parola one time primită a expirat, apăsați "Reîncercă" pentru a primi una nouă.</p>
              } @else if (!passwordEntered) {
                <p>Introduceți parola certificat și apăsați "{{ signLabel }}".</p>
              } @else {
                <p>Introduceți parola one time primită prin SMS și apăsați "{{ signLabel }}" pentru a finaliza
                  semnarea.</p>
              }
              @if (!passwordEntered) {
                <form (ngSubmit)='start()' #passForm='ngForm'>
                  <div class='formgrid grid'>
                    <div class='field col-12 md:col-6 xl:col-4'>
                      <input id='password' name='password' type='text' autocomplete='one-time-code'
                             placeholder='Parolă certificat' class='p-2 w-full' required pInputText pRipple
                             [(ngModel)]='password'>
                    </div>
                  </div>
                  <button type='submit' class='p-button-raised px-4 pb-1 pt-2 p-button-rounded button-ipensii' pButton
                          pRipple ipSharedMultiClickPrevention [label]='signLabel'>
                  </button>
                </form>
              } @else {
                <form (ngSubmit)='sign()' #otpForm='ngForm'>
                  <div class='formgrid grid'>
                    <div class='field col-12 md:col-6 xl:col-4'>
                      <input id='otp' name='otp' inputmode='numeric' autocomplete='one-time-code' pattern='[0-9]*'
                             placeholder='Parolă semnătură One Time  SMS' class='p-2 w-full' required pInputText pRipple
                             [disabled]='otpExpired' [(ngModel)]='otp'>
                    </div>
                  </div>
                  @if (otpExpired) {
                    <button type='button' class='p-button-raised px-4 pb-1 pt-2 p-button-rounded button-ipensii' pButton
                            pRipple ipSharedMultiClickPrevention [label]='retryLabel' (click)='start()'>
                    </button>
                  } @else {
                    <button type='submit' class='p-button-raised px-4 pb-1 pt-2 p-button-rounded button-ipensii' pButton
                            pRipple ipSharedMultiClickPrevention [label]='signLabel'>
                    </button>
                    <span class='inline-block ml-3 mb-1'>
                      Poți reîncerca în (<countdown [config]='cntConfig' (event)='notify($event)'></countdown>)
                    </span>
                  }
                </form>
              }
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
